<template>
  <nav class="simple-nav d-flex mb-5 flex-wrap">
    <template v-for="(option, i) in options">
      <button
        :key="i"
        :class="{
          'text-secondary': value !== option.id,
          'text-primary font-weight-bold': value === option.id
        }"
        @click="$emit('input', option.id)"
      >
        {{ option.name }}
      </button>
    </template>
  </nav>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.simple-nav {
  button {
    background: transparent;
    border: none;
    padding: 0;
    padding-bottom: 4px;

    &:not(:last-child) {
      margin-right: 40px;
    }
  }
}
</style>
